import React from 'react';
import { css } from '@bts-web/utils-style-engine';
import { SVGIconType } from '../types';

const FilledExclamationMark: React.FC<SVGIconType> = ({
  color,
  size = 22,
  width,
  height,
  className,
  ...restProps
}) => {
  const wrapperClassName = css({
    color: color || 'neutrals.text_primary',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: width || size,
    height: height || size,
  });

  return (
    <span
      data-testid="icon_exclamation-mark"
      className={
        className ? `${wrapperClassName} ${className}` : wrapperClassName
      }
      data-element="icon"
      aria-label="exclamation-mark icon"
      {...restProps}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 33 33"
        width={`${size}px`}
        height={`${size}px`}
        fill="currentcolor"
      >
        <path d="M17.5625 10.5C17.5625 11.0523 17.1148 11.5 16.5625 11.5C16.0102 11.5 15.5625 11.0523 15.5625 10.5C15.5625 9.94772 16.0102 9.5 16.5625 9.5C17.1148 9.5 17.5625 9.94772 17.5625 10.5ZM15.8125 14.25L15.8125 21.75C15.8125 22.1642 16.1483 22.5 16.5625 22.5C16.9767 22.5 17.3125 22.1642 17.3125 21.75L17.3125 14.25C17.3125 13.8358 16.9767 13.5 16.5625 13.5C16.1483 13.5 15.8125 13.8358 15.8125 14.25ZM4.5625 16.5C4.5625 9.87258 9.93508 4.5 16.5625 4.5C23.1899 4.5 28.5625 9.87258 28.5625 16.5C28.5625 23.1274 23.1899 28.5 16.5625 28.5C9.93508 28.5 4.5625 23.1274 4.5625 16.5ZM16.5625 6C10.7635 6 6.0625 10.701 6.0625 16.5C6.0625 22.299 10.7635 27 16.5625 27C22.3615 27 27.0625 22.299 27.0625 16.5C27.0625 10.701 22.3615 6 16.5625 6Z" />
      </svg>
    </span>
  );
};

export { FilledExclamationMark };
